import * as React from "react"
import { SVGProps, Ref, forwardRef, memo } from "react"
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fill: "currentColor",
    }}
    viewBox="0 0 169.06 169.06"
    ref={ref}
    {...props}
  >
    <title>{"instagram"}</title>
    <path d="M122.41 0H46.65A46.71 46.71 0 0 0 0 46.65v75.76a46.71 46.71 0 0 0 46.65 46.65h75.76a46.71 46.71 0 0 0 46.65-46.65V46.65A46.71 46.71 0 0 0 122.41 0Zm31.65 122.41a31.69 31.69 0 0 1-31.65 31.65H46.65A31.69 31.69 0 0 1 15 122.41V46.65A31.69 31.69 0 0 1 46.65 15h75.76a31.69 31.69 0 0 1 31.65 31.65v75.76Z" />
    <path d="M84.53 41a43.56 43.56 0 1 0 43.56 43.56A43.61 43.61 0 0 0 84.53 41Zm0 72.12a28.56 28.56 0 1 1 28.56-28.56 28.59 28.59 0 0 1-28.56 28.53ZM129.92 28.25a11 11 0 1 0 7.78 3.22 11 11 0 0 0-7.78-3.22Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgComponent)
const Memo = memo(ForwardRef)
export default Memo
